import React from 'react';
import { questionsApi } from '../api/questionsApi';
import type { QuestionListItem } from '../types';

export function useQuestionList(surveyId?: number): {
  questions: QuestionListItem[];
  isLoading: boolean;
  error: Error | null;
  remove: (questionId: number) => Promise<void>;
  refresh: () => void;
} {
  const [questions, setQuestions] = React.useState<QuestionListItem[]>([]);
  const [isLoading, setIsLoading] = React.useState(true);
  const [error, setError] = React.useState<Error | null>(null);
  const [tick, setTick] = React.useState(0);

  React.useEffect(() => {
    let cancelled = false;
    setIsLoading(true);
    setError(null);

    questionsApi
      .listQuestions(surveyId)
      .then((res) => {
        if (!cancelled) setQuestions(res.questions);
      })
      .catch((err: Error) => {
        if (!cancelled) setError(err);
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });

    return () => { cancelled = true; };
  }, [surveyId, tick]);

  const remove = React.useCallback(async (questionId: number) => {
    await questionsApi.archiveQuestion(questionId);
    setTick((t) => {return t + 1});
  }, []);

  const refresh = React.useCallback(() => {return setTick((t) => {return t + 1})}, []);

  return { questions, isLoading, error, remove, refresh };
}
